import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
// @ts-expect-error cannot find declaration file
import AdsSafeStorage from 'AdsUI/lib/AdsSafeStorage'; // @ts-expect-error cannot find declaration file

import { getAudienceUsageInfo } from 'AdsUI/actions/AudiencesActions';
import { hasGoalsInAdsAccess, hasDemoScope, hasWriteScope, isStarterTier // @ts-expect-error cannot find declaration file
} from 'AdsUI/selectors/AuthSelectors';
import { DISMISS_CREATE_AUDIENCE, DISMISS_CREATE_DROPDOWN // @ts-expect-error cannot find declaration file
} from 'AdsUI/lib/StorageKeys'; // @ts-expect-error cannot find declaration file

import { trackEvent } from 'AdsUI/lib/usageTracker'; // @ts-expect-error cannot find declaration file

import withQueryParams from 'AdsUI/lib/withQueryParams'; // @ts-expect-error cannot find declaration file

import AudiencePanelNavigator from 'AdsUI/components/audiences/AudiencePanelNavigator'; // @ts-expect-error cannot find declaration file

import EventCreationPanelContainer from 'AdsUI/containers/events/EventCreationPanelContainer';
import HeaderCreateButtons from 'AdsUI/components/HeaderCreateButtons'; // @ts-expect-error cannot find declaration file

import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink'; // @ts-expect-error cannot find declaration file

import { KBArticles } from 'AdsUI/lib/Constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UIButton from 'UIComponents/button/UIButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';

const HeaderCreationContainer = ({
  hasEvents,
  hasGoalsInAdsScope,
  demoScopeEnabled,
  starterTier,
  writeScopeEnabled,
  eventCreationPanelOpen,
  query,
  deleteQueryParam
}) => {
  const dispatch = useDispatch();
  const cancelledGoalCreation = query.get('goalCancelled');
  const [showAudienceTour, setShowAudienceTour] = useState(!AdsSafeStorage.getItem(DISMISS_CREATE_AUDIENCE));
  const [showDropdownTour, setShowDropdownTour] = useState(!AdsSafeStorage.getItem(DISMISS_CREATE_DROPDOWN));
  const [audienceCreationPanelOpen, setAudienceCreationPanelOpen] = useState(false);
  useEffect(() => {
    dispatch(getAudienceUsageInfo());
  }, [dispatch]);
  useEffect(() => {
    if (cancelledGoalCreation) {
      trackEvent('goalCreationAction', {
        action: 'Cancelled goal creation'
      });
      deleteQueryParam(['goalCancelled']);
    }
  }, [cancelledGoalCreation, deleteQueryParam]);

  const closeAudienceShepherd = () => {
    AdsSafeStorage.setItem(DISMISS_CREATE_AUDIENCE, true);
    setShowAudienceTour(false);
  };

  const closeDropdownShepherd = () => {
    AdsSafeStorage.setItem(DISMISS_CREATE_DROPDOWN, true);
    trackEvent('dismissGoalsShepherd', {
      action: 'Closed goal feature pop-up'
    });
    setShowDropdownTour(false);
  };

  const handleAudienceCreateButtonClick = () => {
    setAudienceCreationPanelOpen(true);
  };

  const handleAudienceCreationPanelClosed = () => {
    setAudienceCreationPanelOpen(false);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIPopover, {
      use: "shepherd",
      open: showDropdownTour && hasGoalsInAdsScope,
      placement: "left bottom",
      autoPlacement: false,
      width: 350,
      className: "m-right-1",
      content: {
        header: /*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "tours.createDropdown.header"
          })
        }),
        body: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "tours.createDropdown.body"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(KnowledgeBaseLink, {
            kbArticle: KBArticles.CREATE_AD_GOALS,
            context: "create-ad-goals",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "tours.createDropdown.feature"
            })
          })]
        }),
        footer: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: closeDropdownShepherd,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "tours.createDropdown.footer"
          })
        })
      },
      children: /*#__PURE__*/_jsx(HeaderCreateButtons, {
        hasEvents: hasEvents,
        hasGoalsInAdsScope: hasGoalsInAdsScope,
        onOpenAudiencePanel: handleAudienceCreateButtonClick,
        showAudienceTour: showAudienceTour && (demoScopeEnabled || writeScopeEnabled) && starterTier,
        closeAudienceShepherd: closeAudienceShepherd
      })
    }), audienceCreationPanelOpen && /*#__PURE__*/_jsx(AudiencePanelNavigator, {
      onClose: handleAudienceCreationPanelClosed
    }), hasEvents && eventCreationPanelOpen && /*#__PURE__*/_jsx(EventCreationPanelContainer, {})]
  });
};

export default connect(state => ({
  eventCreationPanelOpen: state.events.panelState.panelOpen,
  hasGoalsInAdsScope: hasGoalsInAdsAccess(state),
  demoScopeEnabled: hasDemoScope(state),
  starterTier: isStarterTier(state),
  writeScopeEnabled: hasWriteScope(state)
}))(withQueryParams(HeaderCreationContainer));